/**
 * Created by stonewang on 2017/8/29.
 */
import {config, request, objectSerial} from 'Utils';

/*获取子账号的账号*/
export function detail(param) {
    return request(`${config.server}/api/v1/dms/employee/getAccount/${param}`);
}
/*获取子账号的账号*/
export function giveAcount(param) {
    return request(`${config.server}/api/v1/dms/employee/getAccount/${param}`);
}
/*获取二级客户子账号的账号*/
export function getSecondChildAccount(param) {
    return request(`${config.server}/api/v1/dms/employee/getSecondChildAccount`, {
        body: param
    });
}
/*客户详情页接口*/
/*客户详情接口*/
export function linkMandetail(param) {
  return request(`${config.server}/api/v1/dms/employee/detailEmp?id=${param}`);
}

/*下浮设置详情接口*/
export function lowerDetail(param) {
  return request(`${config.server}/api/v1/dms/trans/rate/detail?id=${param}`);
}
/*新增子账户-保存接口*/
export function add(param) {
    return request(`${config.server}/api/v1/dms/employee/insert`, {
        method: 'post',
        body: param,
    });
}
/*新增子账户-保存接口*/
export function insertSecondChild(param) {
    return request(`${config.server}/api/v1/dms/employee/insertSecondChild`, {
        method: 'post',
        body: param,
    });
}
/*下浮设置保存接口*/
export function saveLower(param) {
    return request(`${config.server}/api/v1/dms/trans/rate/create`, {
        method: 'post',
        body: param,
    });
}
/*编辑子账户-保存接口*/
export function update(param) {
    return request(`${config.server}/api/v1/dms/employee/update`, {
        method: 'post',
        body: param,
    });
}
/*新增子账户-获取字典数据项值列表--数据项sKey（性别查询）*/
export function sKeylist(param) {
    return request(`${config.server}/api/v1/dms/dictionayDependent/sKeylist?${objectSerial(param)}`);
}
/*新增子账户-账户类型查询*/
export function account_type(param) {
    return request(`${config.server}/api/v1/dms/employee/getRoles?${objectSerial(param)}`);
}
/*新增子账户-通过code获取账户类型查询*/
export function getRoleListByCondition(code) {
    return request(`${config.server}/api/v1/dms/employee/getRoleListByCondition`, {
        method: 'post',
        body: {
            code: code || "SECOND_CUSTOMER"
        },
    });
}
/*开通账号/禁用账号/修改密码*/
export function optionsBtn(param) {
    return request(`${config.server}/api/v1/dms/employee/updateStatus`, {
        method: 'post',
        body: param,
    });
}

export function optionsRest(param) {
    return request(`${config.server}/api/v1/dms/employee/update`, {
        method: 'post',
        body: param,
    });
}





// WEBPACK FOOTER //
// ./src/service/customerManagement/linkman.js